"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollToTop = void 0;
const react_1 = __importDefault(require("react"));
const button_1 = require("@kyruus/button");
const ArrowUp2_1 = __importDefault(require("@kyruus/react-ikons/ArrowUp2"));
const ScrollToTop = ({ bodyTop, scrollToTopLabel = 'Back to top', onScroll }) => {
    const handleScroll = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (onScroll) {
            onScroll();
        }
    };
    return (react_1.default.createElement("div", { "aria-hidden": true, style: {
            position: 'fixed',
            top: `${bodyTop}px`,
            left: 0,
            zIndex: 100000,
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'center',
            height: '0px',
            width: '100vw'
        } },
        react_1.default.createElement(button_1.ButtonWithIcon, { style: { marginTop: '16px' }, mode: "floating-primary", onClick: handleScroll, icon: react_1.default.createElement(ArrowUp2_1.default, null), active: true }, scrollToTopLabel)));
};
exports.ScrollToTop = ScrollToTop;
//# sourceMappingURL=ScrollToTop.js.map